<button
    class="icon-button"
    [disabled]="disabled()"
    (click)="onClick($event)">
  <img
      [src]="isImageActive() ? activeImgSrc() : inactiveImgSrc()"
      [alt]="altText()"
      [matTooltip]="tooltipText()"
      [matTooltipPosition]="tooltipPosition()"
      [matTooltipDisabled]="tooltipDisabled()"
      [matTooltipClass]="tooltipCustomClass()" />
</button>